export const enum GameRequest {
    SPIN = `SPIN`,
    WHEEL_SPIN = `WHEEL_SPIN`,
    FREE_SPIN = `FREE_SPIN`
}

export const enum GameEvent {
    OPEN_GAME = `OPEN_GAME`,
    INITIAL_SPIN = `INITIAL_SPIN`,
    INITIAL_WHEEL = `INITIAL_WHEEL`,
    FREE_SPIN = `FREE_SPIN`,
    FREE_SPIN_WHEEL = `FREE_SPIN_WHEEL`,
    SPIN_ERROR = `SPIN_ERROR`
}